const correctPassword = "feelalive"; // Change this to your desired password

  function setCookie(name, value, days) {
      let expires = "";
      if (days) {
          let date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
  }

  function getCookie(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
  }

  function checkPassword() {
      let inputPassword = document.getElementById("password").value.toLowerCase();
      console.log(inputPassword,correctPassword);
      if (inputPassword === correctPassword) {
          setCookie("accessGranted", "true", 1);
          document.getElementById("pass-overlay").style.display = "none";
      } else {
          document.getElementById("error").style.display = "block";
      }
  }

  window.onload = function() {
    if (getCookie("accessGranted") === "true") {
      document.getElementById("pass-overlay").style.display = "none";
    }
    else{
      document.getElementById("pass-overlay").style= "";  
    }
    document.querySelector('.pass-overlay-content').style= "";  
  }